import { useSearchParams } from "react-router-dom";
import { assetAllocationPages } from "@app/const/route.const";
import { ModuleSummaryReport } from "@app/pages/portfolioAnalysis/pdfSummaryReport/ModuleSummaryReport";

export const PdfAssetAllocationModuleSummaryReportPage = () => {
  const [searchParams] = useSearchParams();
  const { portfolioGroupId, moduleId, data1Id, data2Id } =
    assetAllocationPages.getPdfModuleSummaryReportParams(searchParams);

  return (
    <ModuleSummaryReport
      portfolioGroupId={portfolioGroupId}
      moduleId={moduleId}
      data1Id={data1Id}
      data2Id={data2Id}
      footer="Asset Allocation"
    />
  );
};
